// components/RouteMap.js
import React, { useMemo } from 'react';
import {
  Typography,
} from '@material-ui/core';
import { GoogleMap, Marker } from '@react-google-maps/api';
import CustomMarker from './CustomMarker';
import { mapContainerStyle } from '../DailyScheduleMapViewStyles';
import {
  normalizedMarkerPosition
} from '../utils/geoUtils'

const RouteMap = ({
  isLoaded,
  center,
  zoomLevel,
  mapRef,
  loading,
  filteredMarkers,
  highlightedSite,
  activeMarker,
  onMarkerClick,
  selectedCrew,
  crewLocations,
  highlightedStop,
  crewLocsWithColor
}) => {
  if (!isLoaded) {
    return (
      <div style={{ backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography>Loading Google Maps...</Typography>
      </div>
    );
  }
  const markersWithSelection = useMemo(() => {
    return filteredMarkers.map(marker => ({
      ...marker,
      isSelectedCrew: selectedCrew && (marker.crew === selectedCrew._id || marker.crewId === selectedCrew._id),
      // Preserve the original color if not selected crew
      displayColor: selectedCrew && (marker.crew === selectedCrew._id || marker.crewId === selectedCrew._id) 
        ? selectedCrew.color 
        : marker.color
    }));
  }, [filteredMarkers, selectedCrew]);

  
  const displayMarkers = useMemo(() => {
    if (!selectedCrew) return filteredMarkers;
    
    // Filter to show only selected crew's markers
    return filteredMarkers.filter(marker => 
      marker.crew === selectedCrew._id || 
      marker.crewId === selectedCrew._id
    );
  }, [filteredMarkers, selectedCrew]);

  const updateActiveMarker = (m) => {
    console.log('update the active marker', m)
    onMarkerClick(m)
  }

  // console.log('activeMarker...', activeMarker)
  // console.log('filteredMarkers...', filteredMarkers)
  let chad = true
  return (
    <div style={{ backgroundColor: 'pink', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
    {(chad && isLoaded) ? (
      <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={center}
      mapTypeId={'hybrid'}
      zoom={zoomLevel}
      onLoad={(map) => { 
        console.log('Got our map??', map)
        mapRef.current = map; 
      }}
      options={{ 
        gestureHandling: "greedy",
        zoomControl: true,
        zoomControlOptions: {
          position: window.google?.maps?.ControlPosition?.LEFT_TOP,
        },
      }}
    >
        {!loading && markersWithSelection.map((marker, index) => {
          // console.log('Marker to display', marker)
          
          return (
          <CustomMarker
            key={index}
            position={normalizedMarkerPosition(marker)}
            icon={marker.jobType}
            highlightedSite={highlightedSite}
            color={marker.color}
            jobsite={marker}
            activeMarker={activeMarker}
            highlightedStop={highlightedStop}
            updateActiveMarker={updateActiveMarker}
            hideInfoWindowOnActiveItem={true}
            showOrderNumbers={marker.isSelectedCrew} // Only show order numbers for selected crew
            // Optional: add opacity or different styling for non-selected crews
            opacity={marker.isSelectedCrew ? 1.0 : 0.6}
          />
        )})}
        {(!loading && !activeMarker?._id) && (crewLocsWithColor || []).map((crewMarker, index) => {
          let latitude = crewMarker?.lastLocation?.latitude;
          let longitude = crewMarker?.lastLocation?.longitude;
          let theIcon = {
            path: window.google?.maps?.SymbolPath?.FORWARD_CLOSED_ARROW,
            scale: 3,
            fillColor: crewMarker.color,
            fillOpacity: 0.8,
            strokeWeight: 2,
            rotation: 0,
            strokeColor: crewMarker.color
          };
          
          return (
            <Marker
              key={index}
              icon={theIcon}
              position={normalizedMarkerPosition(crewMarker)}
              title={crewMarker.name}
              color={crewMarker.color}
            />
          );
        })}
        {activeMarker?._id && (
          <Marker
            key={activeMarker._id}
            position={normalizedMarkerPosition(activeMarker)}
            title={activeMarker.name}
            icon={{
              path: 'M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z',
              fillColor: (() => {
                // If it's a selected crew's marker, use their color
                if (selectedCrew && (activeMarker.crew === selectedCrew._id || activeMarker.crewId === selectedCrew._id)) {
                  return selectedCrew.color;
                }
                // Otherwise use the marker's color or default to red
                return activeMarker.color || '#FF0000';
              })(),
              fillOpacity: 1,
              strokeColor: '#FFFFFF',
              strokeWeight: 2,
              scale: 1.5,
              anchor: new window.google.maps.Point(12, 17),
              labelOrigin: new window.google.maps.Point(12, 9),
            }}
            label={selectedCrew && activeMarker.orderNumber ? {
              text: activeMarker.orderNumber.toString(),
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold'
            } : undefined}
          />
        )}
        {/* {(!loading && !activeMarker?._id) && (crewLocsWithColor || []).map((crewMarker, index) => { */}

      </GoogleMap>
    ) : (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography>Loading Google Maps...</Typography>
      </div>
    )}
  </div>

  );
};

export default RouteMap;